module.exports = __webpack_public_path__ + "static/top-bg-5db2945a0e2dc6700d0f9ade83ed328e.png";